import { Box, Checkbox, FormControlLabel, Tooltip, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

const SquareCheckBox = ({
  label = "",
  checked,
  onChange = () => { },
  readOnly = false,
  disabled = false,
  tooltip
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box sx={{ width: "auto", display: "inline-flex" }}>
      <FormControlLabel
        label={
          <Tooltip title={t(tooltip || "")} arrow placement="right">
            <Typography sx={{
              fontFamily: "Poppins, sans-serif",
              fontSize: "13.5px",
              fontWeight: 500,
              color: theme.palette.text.subtitle || "inherit",
              ml: 1,
              textAlign: "left",
              lineHeight: 1,
              display: "inline-block",
              userSelect: "none",
            }}>
              {t(label)}
            </Typography>
          </Tooltip>
        }
        control={
          <Checkbox
            disableRipple
            checked={checked}
            onChange={onChange}
            readOnly={readOnly}
            disabled={disabled}
            sx={{
              p: 0.5,
              color: theme.palette.text.subtitle,
              "&.Mui-checked": { color: theme.palette.mode === "dark" ? "#4ade80" : "#659d33" }
            }}
          />
        }
        sx={{
          m: 0,
          display: "flex",
          alignItems: "center",
        }}
      />
    </Box>
  );
};

export default SquareCheckBox;
